import { Alert } from "@material-ui/lab";
import React from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { TimestampToDateMoment } from "../../../utils/timestampToDate";
import NicknameFormItem from "../../elements/clients/NicknameFormItem";
import PageSpinner from "../../elements/spinner/PageSpinner";
import { StyledBreakWord } from "../../styles/styledBreakWord";

import {
  StyledCol,
  StyledScrollTable,
  StyledTable,
  StyledTableBody,
  StyledTableHead,
  StyledTableRow
} from "../../styles/styledTable";

const ClientsList = ({ clients, notification, setNotification }) => {
  const { t } = useTranslation("clientsPage");

  const showDetails = (e) => {
    if (e.target.closest(".stop-event")) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  if (!clients) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  if (clients.length === 0) {
    return <Alert severity="warning">{t("table.emptyData")}</Alert>;
  }

  return (
    <StyledScrollTable>
      <StyledTable
        width="1280"
        size="14"
        className="client-table"
      >
        <StyledTableHead
          scroll="auto"
          col="4"
          className="client-table__head"
        >
          <div>
            {t("table.nickname")}
          </div>
          <div>
            {t("table.firstname")}
          </div>
          <div>
            {t("table.lastname")}
          </div>
          <div>
            E-mail
          </div>
          <div>
            {t("table.createDate")}
          </div>
          <div>
            {t("table.lastTransactionCreatedAt")}
          </div>
        </StyledTableHead>
        <StyledTableBody>
          {clients && clients.map((value, key) => (
            <StyledTableRow
              key={key}
              scroll="auto"
              className="client-table__row"
              onClick={(e) => {showDetails(e);}}
              as={NavLink}
              to={`/clients/${value.id}`}
            >
              <StyledCol>
                <NicknameFormItem
                  client={value}
                  t={t}
                  notification={notification}
                  setNotification={setNotification}
                />
              </StyledCol>
              <StyledCol data-action="details">
                {value.firstname ?? t("table.empty")}
              </StyledCol>
              <StyledCol data-action="details">
                {value.lastname ?? t("table.empty")}
              </StyledCol>
              <StyledCol data-action="details" inline>
                <StyledBreakWord as="p">
                  {value.email}
                </StyledBreakWord>
              </StyledCol>
              <StyledCol data-action="details">
                {TimestampToDateMoment(value.createDate)}
              </StyledCol>
              <StyledCol data-action="details">
                {value.lastTransactionCreatedAt ? TimestampToDateMoment(value.lastTransactionCreatedAt) : "--"}
              </StyledCol>
            </StyledTableRow>
          ))}
        </StyledTableBody>
      </StyledTable>
    </StyledScrollTable>
  );
};
export default ClientsList;